import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import DashboardTabs from '@components/common/Dashboard/DashboardTabs';
import { viewersBrowserTabFeatureSelector } from '@store/common/selectors';
import { TabRow, TabWrapper } from './styled';

function Tabs() {
  const { id = null }: any = useParams();

  // hide tabs if impacted viewers is enabled
  const vmBrowserTabEnabled = useSelector(viewersBrowserTabFeatureSelector);

  return (
    <TabRow style={vmBrowserTabEnabled ? { display: 'none' } : {}}>
      <TabWrapper>
        <DashboardTabs id={id} hidden={vmBrowserTabEnabled} />
      </TabWrapper>
    </TabRow>
  );
}

export default Tabs;
